import { render, staticRenderFns } from "./ChartLink.vue?vue&type=template&id=2538308c"
import script from "./ChartLink.vue?vue&type=script&lang=js"
export * from "./ChartLink.vue?vue&type=script&lang=js"
import style0 from "./ChartLink.vue?vue&type=style&index=0&id=2538308c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports